import React from "react";
import { useParams } from "react-router-dom";
import { blogPosts } from "./blogData";
import "./blog.css";
import Navbar from "../NavBar/NavBar.js";
import Spinner from "../Home/Spinner.js";
import Footer from "../Home/Footer.js";
import Whatsapp from "../Home/Whatsapp.js";

export default function BlogPost() {
  const { id } = useParams();
  const post = blogPosts.find(p => p.id === id);

  if (!post) return <div>Article non trouvé</div>;

  return (
    <>
      <Spinner />
      <Navbar />
      <Whatsapp />

      <div className="blog-post">
        <div className="blog-post-hero">
          <h2 className="section-titles">{post.title}</h2>
          <span style={{ color: "#807773" }}>{post.date}</span>
          <br /><br />

          {/* Image de couverture */}
          {post.cover && (
            <img src={post.cover} alt={post.title} />
          )}

          

          
        </div>
        

        <div className="blog-content">
          {post.content.split("\n").map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
        {/* Zone vidéo (affichée seulement si elle existe) */}
          {post.video && (
            <div className="blog-video">
              <iframe src="https://www.youtube.com/embed/ulRL245KL6E" title="UNIK SYSTEM au Salon International du Revêtement 2026 – Casablanca" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          )}
      </div>

      <Footer />
    </>
  );
}
